import {
    CarritoState,
    CarritoActionTypes,
    CARRITO_ADD_ITEM,
    CARRITO_REMOVE_ITEM,
    CARRITO_UPDATE_CANTIDAD,
    CARRITO_CLEAR,
} from './types';

const initialState: CarritoState = {
    items: [],
};

export function carritoReducer(
    state = initialState,
    action: CarritoActionTypes
): CarritoState {
    switch (action.type) {
        case CARRITO_ADD_ITEM: {
            const existente = state.items.find(i => i.productoId === action.payload.productoId);
            if (existente) {
                const nuevaCantidad = Math.min(existente.cantidad + action.payload.cantidad, existente.stockDisponible);
                return {
                    items: state.items.map(i =>
                        i.productoId === action.payload.productoId ? { ...i, cantidad: nuevaCantidad } : i
                    ),
                };
            }
            return { items: [...state.items, action.payload] };
        }
        case CARRITO_REMOVE_ITEM:
            return { items: state.items.filter(i => i.productoId !== action.payload) };
        case CARRITO_UPDATE_CANTIDAD: {
            const { productoId, cantidad } = action.payload;
            if (cantidad <= 0) {
                return { items: state.items.filter(i => i.productoId !== productoId) };
            }
            return {
                items: state.items.map(i =>
                    i.productoId === productoId
                        ? { ...i, cantidad: Math.min(cantidad, i.stockDisponible) }
                        : i
                ),
            };
        }
        case CARRITO_CLEAR:
            return { items: [] };
        default:
            return state;
    }
}
